const formatAttribute = (value: string): string => {
  return value?.toLocaleLowerCase().replace(/ /g, "-");
};

export default formatAttribute;
